// Declaraciones globales para evitar errores de tipo con window
declare global {
  interface Window {
    __AUTH_LOGS?: any[];
    __TRACES_LOGS?: any[];
    __ARGO_AUTH_STORE__?: any;
  }
}

// ⚠️ NOTA: Ya NO es necesario importar los interceptores manualmente
// Los interceptores se registran automáticamente al llamar a cada provider
// (provideArgoAuth, provideArgoConfig, etc.)

import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { provideArgoAuth } from '@argo/authentication';
import { UrlHelperService } from 'angular-oauth2-oidc';
import { provideHttpClient } from '@angular/common/http';
import { provideArgoTraces } from '@argo/traces';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideArgoConfig, ENV_CONFIG } from '@argo/config';
import { provideSecurityConfig } from '@argo/security';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideMultilanguage } from '@argo/multilanguage';
import { provideGoogleTagManager } from 'angular-google-tag-manager';
import { withArgoInterceptors } from '@argo/common';
import { provideScaLibConfig } from '@argo-dev-components-sca-angular/dev-components-sca';


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    { provide: ENV_CONFIG, useValue: environment },
    
    // ✅ NUEVO SISTEMA: withArgoInterceptors() registra automáticamente
    // todos los interceptores de las librerías Argo
    provideHttpClient(
      withArgoInterceptors()  // ← Reemplaza withInterceptors([...])
    ),
    
    // Los providers registran sus interceptores automáticamente
    provideArgoConfig(),
    provideSecurityConfig(),
    provideArgoTraces(),
    provideMultilanguage({
      supportedLangs: ['es-ES', 'en-US','pt-BR'],
      defaultLang: 'es-ES'
    }),
    { provide: '_UrlHelperService', useClass: UrlHelperService },
    provideArgoAuth({ browserStorage: 'session', autoConfigureOAuthRoute: false }),
    
    provideGoogleTagManager({ id: 'GTM-NV4LZQVR' }),
    
    // Configuración de SCA Design System
    provideScaLibConfig({
      assetsPath: '/assets/',
      fonts: ['gilroy', 'roboto'],
      id: 'dev-apa-angular-spa-v8'
    })
  ]
};
